export const advancePayConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getAdvancePaySetupList_request: "getAdvancePaySetupList_request",
        getAdvancePaySetupList_success: "getAdvancePaySetupList_success",
        getAdvancePaySetupList_failure: "getAdvancePaySetupList_failure",

        getAllAdvancePaySetupList_request: "getAllAdvancePaySetupList_request",
        getAllAdvancePaySetupList_success: "getAllAdvancePaySetupList_success",
        getAllAdvancePaySetupList_failure: "getAllAdvancePaySetupList_failure",

        addAccount_request: "addAccount_request",
        addAccount_success: "addAccount_success",
        addAccount_failure: "addAccount_failure",

        updateAccount_request: "updateAccount_request",
        updateAccount_success: "updateAccount_success",
        updateAccount_failure: "updateAccount_failure",
        
        generateInvoice_request: "generateInvoice_request",
        generateInvoice_success: "generateInvoice_success",
        generateInvoice_failure: "generateInvoice_failure",

        generateDebitNote_request: "generateDebitNote_request",
        generateDebitNote_success: "generateDebitNote_success",
        generateDebitNote_failure: "generateDebitNote_failure",

        deleteAccount_request: "deleteAccount_request",
        deleteAccount_success: "deleteAccount_success",
        deleteAccount_failure: "deleteAccount_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.advancePay/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}